<div id="contentAbc">
    <app-sidebar *ngIf="isLoggedIn; else guestTemplate" data-testid="appsidebar" (signOutClicked)="logout()"></app-sidebar>

    <ng-template #guestTemplate>
        <router-outlet></router-outlet>
    </ng-template>
</div>

<app-notification></app-notification>
<app-notification-messages *ngIf="canShowNotificationMessages"></app-notification-messages>

<ng-container
    *ngIf="userRole === userRoleList.COORDINATOR || userRole === userRoleList.MANAGEMENT || userRole === userRoleList.EXECUTIVE_ADMIN"
>
    <app-notification-queue></app-notification-queue>
</ng-container>
